/**
 * Таблица маршрутов. Только форма — ни одного решения о доступе здесь нет:
 * маршрут лишь *объявляет* требование (`meta.public`), а исполняет его
 * `guards.ts`.
 *
 * `meta` типизирована в `types/router.d.ts`, поэтому опечатка в ключе ломает
 * компиляцию, а не превращается в открытый маршрут в рантайме.
 *
 * ───────────────────────────────────────────────────────────────────────────
 *  ЭКРАН ОДИН — И ЭТО ВСЯ АРХИТЕКТУРА НАВИГАЦИИ
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Стойка регистрации делает ровно одно дело: наводит камеру на бейдж. Отсюда
 * нет ни layout-обёртки с сайдбаром, ни вложенных маршрутов, ни `/forbidden`
 * (ролевого гейта нет вовсе: `ResolveParticipantQr` разрешён `anyRole`), ни
 * отдельного 404 — на неизвестный адрес в приложении из одного экрана честнее
 * вернуть этот экран, чем страницу «не найдено» с некуда ведущей кнопкой.
 *
 * Вью — обе ленивые. Форма входа нужна один раз в начале смены, экран
 * сканирования тащит за собой jsQR и работу с камерой; грузить одно вместе с
 * другим означало бы платить за неиспользуемое на телефоне и зальном Wi-Fi.
 */

import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true, title: 'Вход' },
  },

  {
    path: '/',
    name: 'scan',
    component: () => import('@/views/ScanView.vue'),
    meta: { title: 'Сканирование' },
  },

  /**
   * Всё остальное — на экран сканирования. Редирект, а не отдельная вью:
   * гвард отработает на **разрешённом** маршруте, то есть аноним всё равно
   * уедет на `/login`, а вошедший окажется там, куда и шёл.
   */
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'scan' },
  },
]

export default routes
